import { computed, ref } from "vue";
import { defineStore } from "pinia";
import { MobileNotificationProps } from "@shared/types/localTypes/props.ts";
import { InAppNotification } from "@shared/types/common";

export const useInAppNotificationsStore = defineStore(
  "in-app-notifications",
  () => {
    // State
    const _eventChannel = ref<string | null>(null);
    const _highlightedNotification = ref<MobileNotificationProps | null>(null);
    const _inAppNotifications = ref<InAppNotification[]>([]);
    const _isDrawerOpen = ref<boolean>(false);

    // Getters
    const eventChannel = computed(() => _eventChannel.value);
    const highlightedNotification = computed(
      () => _highlightedNotification.value,
    );
    const inAppNotifications = computed(() => _inAppNotifications.value);
    const isDrawerOpen = computed(() => _isDrawerOpen.value);

    // Actions
    const setEventChannel = (channel: string | null) => {
      _eventChannel.value = channel;
    };

    const setHighlightedNotification = (
      notification: MobileNotificationProps | null,
    ) => {
      _highlightedNotification.value = notification;
    };

    const clearHighlightedNotification = () => {
      _highlightedNotification.value = null;
    };

    const setInAppNotifications = (notifications: InAppNotification[]) => {
      _inAppNotifications.value = notifications;
    };

    const setDrawerOpen = (isOpen: boolean) => {
      _isDrawerOpen.value = isOpen;
    };

    return {
      eventChannel,
      highlightedNotification,
      inAppNotifications,
      isDrawerOpen,
      setEventChannel,
      setHighlightedNotification,
      clearHighlightedNotification,
      setInAppNotifications,
      setDrawerOpen,
    };
  },
);
